import SecureLS from 'secure-ls'

const ls = new SecureLS({encodingType: 'aes'})

class BaseService {
    static getHeaders = (isFile) => {
        let headers = new Headers();
        if (!isFile){
            headers.append('Content-Type', 'application/json');
        }
        headers.append('Accept', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('Origin', '*');
        headers.append('Credentials', 'same-origin');

        return headers;
    };

    static getHeadersAuth = (isFile) => {
        let headers = BaseService.getHeaders(isFile);
        let token = ls.get('jwtToken') || '';
        if (token === '') {
          window.location.reload();
        }
        headers.append('Authorization', `Bearer ${token}`);
        return headers;
    };

    static getToken = () => {
        return (ls.get('jwtToken') || '').toString();
    };
    
    static postRequest = async (
        url,
        body,
        required_auth
      ) => {
        let head = required_auth
          ? BaseService.getHeadersAuth()
          : BaseService.getHeaders();
    
        let headers = {
          method: 'POST',
          headers: head,
          mode: 'cors',
          cache: 'default',
          body: JSON.stringify(body)
        };
    
        let response = await fetch(url, headers)
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err;
          });
        return response;
      };

    static putRequest = async (
        url,
        body,
        required_auth
      ) => {
        let head = required_auth
          ? BaseService.getHeadersAuth()
          : BaseService.getHeaders();
    
        let headers = {
          method: 'PUT',
          headers: head,
          mode: 'cors',
          cache: 'default',
          body: JSON.stringify(body)
        };
        let response = await fetch(url, headers)
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err;
          });
        return response;
      };
    static patchRequest = async (
        url,
        body,
        required_auth
      ) => {
        let head = required_auth
          ? BaseService.getHeadersAuth()
          : BaseService.getHeaders();
    
        let headers = {
          method: 'PATCH',
          headers: head,
          mode: 'cors',
          cache: 'default',
          body: JSON.stringify(body)
        };
        let response = await fetch(url, headers)
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err;
          });
        return response;
      };
    
      static deleteRequest = async (
        url,
        required_auth
      ) => {
        let head = required_auth
          ? BaseService.getHeadersAuth()
          : BaseService.getHeaders();
    
        let headers = {
          method: 'DELETE',
          headers: head,
          mode: 'cors',
          cache: 'default'
        };
        let response = await fetch(url, headers)
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err;
          });
        return response;
      };  

    static getRequest = async (url, required_auth) => {
        let head = required_auth
          ? BaseService.getHeadersAuth()
          : BaseService.getHeaders();
    
        let headers = {
          method: 'GET',
          headers: head,
          mode: 'cors',
          cache: 'default'
        };
        let response = await fetch(url, headers)
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err;
          });
        return response;
      };
    
}

export default BaseService;